import React, { useState } from "react";
import {
  dateAndTimeFormatter,
  getCurrentWorkspaceId,
  startApiCall,
} from "../../../../../global-functions/globalFunctions";
import ApiCall from "../../../../../api/ApiCall";
import { activityGroupRelatedEndpoints } from "../../../../../api/Endpoints";
import CustomTooltip from "../../../../../components/CustomTooltip/CustomTooltip";
import { Avatar } from "../../../../../components/Avatar/Avatar";

function RecentActivityCard({
  allActivity,
  setactivityDetails,
  handleGetMandatoryTask,
}) {
  const [loader, setloader] = useState(false);
  const [allStatus, setallStatus] = useState([]);

  const handleGetAllStatus = async (id) => {
    startApiCall(null, setloader);
    const data = {
      page: 1,
      limit: 200,
      filters: {
        businessId: getCurrentWorkspaceId(),
        activityGroupId: id,
      },
    };
    const res = await ApiCall(
      "post",
      activityGroupRelatedEndpoints.getActivitySubStatus,
      data
    );
    if (res?.success) {
      setallStatus(res?.status?.data);
      setloader(false);
    } else {
      setloader(false);
    }
  };

  return (
    <div className="overflow-auto simple-scrollbar h-400p">
      <table className="table nowrap">
        <thead>
          <tr className="">
            <th>Type</th>
            <th>Title</th>
            <th className="ps-5">Status</th>
            <th className="text-center">Deadline</th>
            <th className="text-center">Assignees</th>
            <th className="text-center">Last Modified</th>
          </tr>
        </thead>
        <tbody>
          {allActivity?.map((act) => {
            return (
              <tr>
                <td>
                  <div
                    className="text-uppercase"
                    data-bs-toggle="modal"
                    data-bs-target="#call_details_modal"
                    onClick={() => {
                      setactivityDetails(act);
                    }}
                  >
                    <p className="w-100 overflow-hide nowrap mb-00 fs-7  text-capitalize text-truncate text-link d-flex align-items-center gap-2">
                      {act?.taskType === "task" ? (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.615 20H7C6.46957 20 5.96086 19.7893 5.58579 19.4142C5.21071 19.0391 5 18.5304 5 18V6C5 5.46957 5.21071 4.96086 5.58579 4.58579C5.96086 4.21071 6.46957 4 7 4H15C15.5304 4 16.0391 4.21071 16.4142 4.58579C16.7893 4.96086 17 5.46957 17 6V14M14 19L16 21L20 17M9 8H13M9 12H11"
                            stroke="#979797"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      ) : act?.taskType === "meeting" ? (
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 37 37"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="37" height="37" fill="white" />
                          <path
                            d="M24.0908 18.1947L27.5765 16.0699L27.6738 20.151L24.0908 18.1947Z"
                            stroke="#979797"
                          />
                          <rect
                            x="7.5"
                            y="13.5"
                            width="15.9305"
                            height="9.80051"
                            rx="4.90025"
                            stroke="#979797"
                          />
                        </svg>
                      ) : act?.taskType === "call" ? (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.2647 12.7223C17.1102 12.7223 16.9486 12.673 16.7941 12.6377C16.4811 12.5686 16.1735 12.4767 15.8738 12.363C15.5478 12.2441 15.1896 12.2502 14.868 12.3803C14.5463 12.5104 14.284 12.7552 14.1315 13.0675L13.9769 13.3846C13.2927 13.0028 12.6639 12.5287 12.1082 11.9755C11.5566 11.4181 11.0838 10.7875 10.7032 10.1013L10.9983 9.90402C11.3097 9.75107 11.5538 9.48799 11.6835 9.16541C11.8132 8.84284 11.8193 8.48355 11.7008 8.15669C11.5892 7.85543 11.4977 7.5471 11.4268 7.23371C11.3917 7.0787 11.3636 6.91665 11.3425 6.7546C11.2572 6.25832 10.998 5.80889 10.6116 5.48725C10.2252 5.16561 9.73701 4.9929 9.23492 5.00022H7.12735C6.82459 4.99737 6.52477 5.05998 6.2483 5.18379C5.97182 5.30759 5.7252 5.48968 5.5252 5.71767C5.32521 5.94566 5.17655 6.21419 5.08933 6.50498C5.00211 6.79577 4.9784 7.10199 5.01979 7.4028C5.39405 10.3545 6.73818 13.097 8.83986 15.1972C10.9415 17.2973 13.681 18.6354 16.6255 19H16.8924C17.4105 19.0008 17.9106 18.8101 18.2975 18.4645C18.5197 18.2652 18.6973 18.0208 18.8184 17.7475C18.9395 17.4742 19.0014 17.1783 19 16.8792V14.7655C18.9914 14.2761 18.8137 13.8049 18.4972 13.4323C18.1807 13.0596 17.7451 12.8087 17.2647 12.7223ZM17.616 16.9497C17.6159 17.0497 17.5945 17.1486 17.5533 17.2397C17.5121 17.3308 17.4521 17.4121 17.3772 17.4781C17.2987 17.5461 17.2069 17.5969 17.1077 17.6272C17.0085 17.6575 16.904 17.6668 16.8011 17.6543C14.1701 17.3159 11.7262 16.1088 9.85505 14.2232C7.98387 12.3377 6.79184 9.88101 6.46698 7.24075C6.4558 7.13754 6.4656 7.03314 6.49579 6.93383C6.52598 6.83453 6.57592 6.7424 6.64261 6.66301C6.70845 6.58785 6.78948 6.52762 6.88033 6.48631C6.97118 6.44501 7.06976 6.42358 7.16951 6.42345H9.27707C9.44044 6.41981 9.59997 6.47339 9.72819 6.57498C9.85642 6.67658 9.94532 6.81982 9.97959 6.98006C10.0077 7.17264 10.0428 7.36288 10.085 7.55076C10.1661 7.92217 10.2741 8.28716 10.4081 8.64284L9.4246 9.10081C9.34051 9.13951 9.26486 9.19448 9.20201 9.26258C9.13916 9.33067 9.09034 9.41055 9.05836 9.49762C9.02637 9.58469 9.01185 9.67724 9.01563 9.76996C9.0194 9.86267 9.0414 9.95372 9.08037 10.0379C10.0914 12.2099 11.8323 13.9559 13.998 14.9699C14.1691 15.0403 14.3609 15.0403 14.5319 14.9699C14.6196 14.9384 14.7001 14.8899 14.7688 14.827C14.8375 14.7641 14.8931 14.6881 14.9324 14.6035L15.3679 13.6171C15.7311 13.7474 16.1018 13.8556 16.4779 13.9412C16.6653 13.9835 16.8549 14.0187 17.047 14.0469C17.2067 14.0813 17.3496 14.1704 17.4509 14.299C17.5522 14.4276 17.6056 14.5876 17.602 14.7515L17.616 16.9497Z"
                            fill="#979797"
                          />
                        </svg>
                      ) : (
                        ""
                      )}

                      <span className="btn btn-sm btn-soft-primary fw-bold fs-8">
                        {act?.actionFromRef === "Status" ? "Auto" : "Manual"}
                      </span>
                    </p>
                  </div>
                </td>
                <td>
                  <p
                    className=" overflow-hidden fs-7 "
                    style={{
                      textAlign: "left",
                      width: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {act?.title}
                  </p>
                </td>
                <td>
                  <div className="selectable-dropdown">
                    <div className="dropdown selectable-dropdown text-uppercase">
                      <span
                        className="d-flex align-items-center gap-1 fs-7 text-capitalize dropdown-toggle fw-bold"
                        aria-expanded="false"
                        type="button"
                        data-bs-toggle="dropdown"
                        onClick={() =>
                          handleGetAllStatus(act?.activityGroup?._id)
                        }
                        style={{ maxWidth: "200px" }}
                      >
                        <p
                          className="m-0"
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill={act?.activityGroupStatus?.color}
                            className="bi bi-circle-fill"
                            viewBox="0 0 16 16"
                          >
                            <circle cx="8" cy="8" r="8" />
                          </svg>
                          &nbsp;
                          {act?.activityStatus?.name}
                        </p>
                      </span>

                      <div
                        role="menu"
                        className="dropdown-menu"
                        style={{
                          maxHeight: "30vh",
                          overflow: "auto",
                        }}
                      >
                        {loader ? (
                          <span className="text-center">Loading...</span>
                        ) : allStatus?.length > 0 ? (
                          <>
                            {allStatus?.map((status, index) => {
                              return (
                                <>
                                  <button
                                    className="dropdown-item text-capitalize  d-flex align-items-center border-bottom rounded-0"
                                    type="button"
                                    onClick={() => {
                                      handleGetMandatoryTask(
                                        act?._id,
                                        status?._id,
                                        act,
                                        status?.name
                                      );
                                    }}
                                    disabled={
                                      status?._id === act?.activityStatus?._id
                                    }
                                  >
                                    {index + 1}. {status?.name} (
                                    {status?.activityGroupStatus?.name})
                                  </button>
                                </>
                              );
                            })}
                          </>
                        ) : (
                          <span> No Status Found</span>
                        )}
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <p className="w-100 overflow-hide nowrap mb-00 fs-7 text-uppercase text-center">
                    {act?.dealLineDate
                      ? dateAndTimeFormatter(act?.dealLineDate)
                      : "-"}
                  </p>
                </td>
                <td>
                  <div className="text-center">
                    {act?.assignees?.length > 0 && (
                      <div className="avatar-group avatar-group-sm avatar-group-overlapped pointer">
                        {act?.assignees?.slice(0, 2)?.map((emp) => {
                          return (
                            <CustomTooltip text={emp?.name} placement="bottom">
                              <Avatar
                                name={emp?.name}
                                count={1}
                                image={emp?.image}
                                size="sm"
                                color="primary"
                              />
                            </CustomTooltip>
                          );
                        })}
                        {act?.assignees?.length > 2 && (
                          <div
                            className="avatar avatar-xs avatar-soft-indigo avatar-rounded"
                            data-bs-toggle="modal"
                            data-bs-target="#call_details_modal"
                            onClick={() => {
                              setactivityDetails(act);
                            }}
                          >
                            <span className="initial-wrap">
                              +{act?.assignees.length - 2}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                    {act?.assignees?.length === 0 && (
                      <span className="font-1">No Assigned Employee </span>
                    )}
                  </div>
                </td>
                <td>
                  <p className="w-100 overflow-hide nowrap mb-00 fs-7 text-uppercase text-center">
                    {dateAndTimeFormatter(act?.updatedAt)}
                  </p>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default RecentActivityCard;
